import React, { useEffect } from "react";
import { GlModal } from "@adl/component-modal";
import { createReactClient } from "@astro-mf/client/react";
import { useDevice, getQueryParams } from "@crystal/core";
import { getMfServer } from "../../client/utils.js";
import { useRuntimeInfo } from "../../integration/hooks.js";
import { closeAccountPortal } from "../../integration/state-triggers.js";
import "../../state/reducers.js";
import "../../state/actions.js";
import "../../state/utils.js";
import "../../store/storage/memory-storage.js";
import "mitt";
import "../../store/storage/universal-memory-storage.js";
import "@reduxjs/toolkit";
import "../../store/state/host.js";
import "../../store/state/modal.js";
import "../../config/source-ids.js";
import { Touchpoint } from "../../config/touchpoints.js";
import { isInlinePreset } from "../../config/preset-utils.js";
import { loadAnalyticsAgent, trackClientOverlayOpen } from "../analytics.js";
import { instanaEventAuthn, AuthnEvents } from "../monitoring.js";
import { Loader } from "./Loader.js";
const ErrorView = () => {
  const { isMobile } = useDevice();
  const runtimeInfo = useRuntimeInfo();
  const { isModalVisible } = runtimeInfo;
  return /* @__PURE__ */ React.createElement(
    GlModal,
    {
      id: "account-portal-client",
      title: "Account Portal Client Modal",
      showTitle: false,
      closeButtonLabel: "",
      disablePortal: true,
      size: isMobile ? "full-mobile" : "small",
      open: isModalVisible,
      onClose: closeAccountPortal
    },
    /* @__PURE__ */ React.createElement("div", null, "Failed to load Account Portal")
  );
};
const mfPath = "/ap/mf";
const isSSR = typeof window === "undefined";
const AccountPortal = createReactClient({
  mfId: "ap/v2",
  server: isSSR ? getMfServer(mfPath) : { default: window.location.origin + mfPath },
  ErrorView,
  onError(error) {
    instanaEventAuthn(
      AuthnEvents.MicrofrontendError,
      {
        errorType: error
      },
      { error: new Error("Failed to load Microfrontend") }
    );
  }
});
const AccountPortalAuthN = (props) => {
  const { isMobile } = useDevice();
  const runtimeInfo = useRuntimeInfo();
  const { isModalVisible } = runtimeInfo;
  const isInlineView = isInlinePreset(props.preset);
  const LoaderView = () => {
    return isInlineView ? /* @__PURE__ */ React.createElement(Loader, { showLogo: true }) : /* @__PURE__ */ React.createElement(
      GlModal,
      {
        id: "client-account-portal",
        title: "Account Portal Client Modal",
        showTitle: false,
        closeButtonLabel: "",
        disablePortal: true,
        size: isMobile ? "full-mobile" : "small",
        open: isModalVisible,
        className: props.className
      },
      /* @__PURE__ */ React.createElement(Loader, { showLogo: true })
    );
  };
  const queryParams = getQueryParams();
  const rpt = props.preset === "reset-password" ? getQueryParams().rpt || void 0 : void 0;
  const aat = props.preset === "account-activation" ? getQueryParams().a || void 0 : void 0;
  const touchpoint = props.touchpoint || runtimeInfo.touchpoint || Touchpoint.Unknown;
  const preset = props.preset || runtimeInfo.preset || "inline";
  const pageContext = { ...props.pageContext, ...runtimeInfo.pageContext };
  const storage = typeof sessionStorage !== "undefined" ? sessionStorage : {};
  const storeId = props.storeId || queryParams.storeId || storage.storeId;
  const sourceId = props.sourceId || queryParams.sourceId || storage.sourceId;
  useEffect(() => {
    loadAnalyticsAgent(props.context);
    trackClientOverlayOpen(touchpoint);
  }, []);
  return /* @__PURE__ */ React.createElement(
    AccountPortal,
    {
      aat,
      env: props.context.env,
      preset,
      touchpoint,
      pageContext,
      hintAcid: runtimeInfo.hintAcid,
      locale: props.context.locale,
      instanceId: props.instanceId,
      className: props.className,
      sourceId,
      storeId,
      styleDependencies: props.loadStyleDependencies,
      noPrerender: props.noPrerender,
      rpt
    },
    /* @__PURE__ */ React.createElement(LoaderView, null)
  );
};
export {
  AccountPortalAuthN
};
//# sourceMappingURL=AccountPortalAuthN.js.map
